import {
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  GoldOutlined,
  TableOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MenuConfigItem } from "../../../../models/sistema/menuConfigItem";

export const contabilidade: MenuConfigItem[] = [
  {
    label: "PAINEL GERAL",
    key: "/painelGeral",
    path: "/painelGeral",
    icon: <DashboardOutlined />,
  },
  {
    label: "SORTEIO",
    key: "/sorteioPai",
    path: "/sorteioPai",
    icon: <CalendarOutlined />,
    children: [
      {
        label: "ANEXOS",
        key: "/anexos",
        path: "/anexos",
      },
    ],
  },
  {
    label: "FINANCEIRO TÁTICO",
    key: "/financeiroTatico",
    path: "/financeiroTatico",
    icon: <GoldOutlined />,
    children: [
      {
        label: "PLANO DE CONTA CONTÁBIL",
        key: "/planoContaContabil",
        path: "/planoContaContabil",
      },
    ],
  },
  {
    label: "CONTABILIDADE",
    key: "/contabilidade",
    path: "/contabilidade",
    icon: <TableOutlined />,
    children: [
      {
        label: "CONTROLE DE GUIA E RECOLHIMENTO",
        key: "/contaFinanceiraGuia",
        path: "/contaFinanceiraGuia",
      },
      {
        label: "PENDÊNCIAS DAS CONTAS A PAGAR",
        key: "/contaFinanceiraContabilidade",
        path: "/contaFinanceiraContabilidade",
      },
      {
        label: "AGENDA DE OBRIGAÇÕES FISCAIS",
        key: "/agendaCompromissoFiscal",
        path: "/agendaCompromissoFiscal",
      },
    ],
  },
  {
    label: "IMPOSTO",
    key: "/imposto",
    path: "/imposto",
    icon: <BankOutlined />,
    children: [
      {
        label: "IMPOSTOS E TAXAS",
        key: "/impostosTaxas",
        path: "/impostosTaxas",
      },
      {
        label: "PERFIL DE TAXA/IMPOSTO",
        key: "/perfilTaxaImposto",
        path: "/perfilTaxaImposto",
      },
      {
        label: "TIPOS DE TAXAS/IMPOSTOS",
        key: "/tipoTaxaImposto",
        path: "/tipoTaxaImposto",
      },
    ],
  },
];
